import InputGroup from "./InputGroup";
import PasswordRequirements from "./PasswordRequirements";

function RegisterForm({ email, setEmail, username, setUsername, password, setPassword, passwordConfirm, setPasswordConfirm }) {
  return (
    <>
      <InputGroup
        label="Email"
        name="email"
        id="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <InputGroup
        label="Username"
        name="username"
        id="username"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
      />
      <div className="input-group">
        <InputGroup
          label="Password"
          name="password"
          id="password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <label htmlFor="password-confirm">Confirm password</label>
        <input
          type="password"
          name="password-confirm"
          id="password-confirm"
          value={passwordConfirm}
          onChange={(e) => setPasswordConfirm(e.target.value)}
        />
        <PasswordRequirements />
      </div>
    </>
  );
}

export default RegisterForm;
